import { render } from "./invoice-settings.vue?vue&type=template&id=b6fb6c8a"
import script from "./invoice-settings.vue?vue&type=script&lang=js"
export * from "./invoice-settings.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__